import { Reveal } from "../Reveal";

export default function ProfileAbout({ profile }) {
  const sectors = (profile.experiences || []).map((e) => e.sector).filter(Boolean);
  return (
    <section id="apropos" className="bg-paper py-24 md:py-32" data-testid="profile-about">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="label-mono text-gold">01 — À propos</span>
            <h2 className="font-display text-3xl md:text-5xl font-semibold mt-4 tracking-tight leading-[1.02]">L'expérience terrain, avant tout.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <dl className="mt-10 rounded-sm border hairline bg-white p-7 space-y-5" data-testid="profile-facts">
              <div><dt className="label-mono text-ink/45">Nom</dt><dd className="font-display text-lg font-semibold mt-1">{profile.name}</dd></div>
              <div><dt className="label-mono text-ink/45">Fonction</dt><dd className="text-ink/75 text-sm mt-1">{profile.job_title}</dd></div>
              {profile.years_experience && <div><dt className="label-mono text-ink/45">Expérience</dt><dd className="text-ink/75 text-sm mt-1">Plus de {profile.years_experience.replace("+", "")} ans en environnements industriels exigeants</dd></div>}
              {sectors.length > 0 && <div><dt className="label-mono text-ink/45">Secteurs</dt><dd className="text-ink/75 text-sm mt-1">{sectors.join(" · ")}</dd></div>}
              <div><dt className="label-mono text-ink/45">Structure</dt><dd className="text-ink/75 text-sm mt-1">NovaLean Consulting — Fondateur</dd></div>
            </dl>
          </Reveal>
        </div>
        <div className="lg:col-span-8 flex flex-col justify-center">
          {(profile.bio || []).map((p, i) => (
            <Reveal key={i} delay={0.06 * i}>
              <p className="text-ink/70 text-lg leading-relaxed mb-6 max-w-3xl">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
